import Select from "react-select";
import { FieldHookConfig, setIn, useField, useFormikContext } from "formik";
import { useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import styled from "@emotion/styled";
import { OptionModel } from "../../../common/types/OptionModel";

const StyledSelect = styled(Select)`
  .css-1hb7zxy-IndicatorsContainer {
    height: 29px !important;
    width: 73px !important;
    display: flex;
    justify-content: flex-end;
  }
  .css-1dimb5e-singleValue {
    height: 32px !important;
    display: flex;
    align-items: center;
  }
  input:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: transparent !important;
  }
`;

 
type SelectorProps = {
  isMulti?: boolean,
  valueWidth?: number,
  onChange?: (name:string, value:string)=>void,
  name?: string,
  defaultValue?: OptionModel,
  value? : any,
  options: Array<OptionModel>,
  label?: string,
  definition?: string,
  required?: boolean,
  placement?: 'auto' | 'bottom' | 'top',
  placeholder?: string,
  isSearchable?: boolean,
  classNamePrefix?: string,
  className?: string,
  menuPortalTarget?: HTMLElement,
  isDisabled?: boolean,
  formSelectorRef? : any,
  isClearable? : boolean,
  id?: string,
  labelHelper?:string,
  successText?:string,
  error?: any,
  touched?: any,
  labelInfoIcon?: React.ReactElement,
  isLazyFrontend?: boolean,
  lazyPageSize?: number,
  loading?: boolean,
}


export default function FormSelector(props:SelectorProps&FieldHookConfig<string> & any) {
  const [field, meta] = useField(props);
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const { isResetForm } = useSelector((state:any) => state.formHelper);
  const selectorRef = useRef<any>();
  const [internalPage, setInternalPage] = useState(1);
  const [displayedOptions, setDisplayedOptions] = useState<OptionModel[]>([]);
  const [inputValue, setInputValue] = useState("");
 
  useEffect(()=>{
    if (isResetForm) {
      onChange({value:0});
      selectorRef.current.clearValue();
    }

  },[isResetForm]); 

  useEffect(() => {
    if (props.isLazyFrontend && props.options.length > 0) {
      const pageSize = props.lazyPageSize || 50;
      const initial = props.options.slice(0, pageSize);
      setDisplayedOptions(initial);
      setInternalPage(2);
    }
  }, [props.options]);

  useEffect(() => {
    if (props.isLazyFrontend && inputValue === "") {
      const pageSize = props.lazyPageSize || 50;
      const initial = props.options.slice(0, pageSize);
      setDisplayedOptions(initial);
      setInternalPage(2);
    }
  }, [inputValue]);

  const customStyles = {
    dropdownIndicator: (base: any) => ({
      ...base,
      padding: "0 8px",
    }),
    control: (base:any, state:any) => ({
      ...base,
      background: props.isMulti ? "#FFFFF" : "#E8EBEF",
      textColor: "#263445",
      // Overwrittes the different states of border
      borderColor: state.isFocused ? "#8D97A4" : "#E8EBEF",
      border: state.isFocused ? "2px solid #0287EF" : "",
      // Removes weird border around container
      height: 32,
      minHeight: 32,

      padding: "0",
      boxShadow: state.isFocused ? null : null,
      // "&:hover": {
      //   // Overwrittes the different states of border
      //   borderColor: state.isFocused ? "#8D97A4" : "#E8EBEF",
      // },
    }),
    valueContainer: (provided:any) => ({
      ...provided,
      height: "32px",
      padding: "0 6px",
      width: props.valueWidth ? props.valueWidth : "100%",
    }),
    
  };

  const onChange = ({ value }:any) => {
    setFieldValue(field.name, value);
    if (props.onChange) {
      props.onChange(props.name, value);
    } 
  };
  const onBlur = () => {
    setFieldTouched(field.name, true); 
  };

  const handleScroll = () => {
    if (props.isLazyFrontend) {
      const pageSize = props.lazyPageSize || 50;
      const filtered = props.options.filter((option: any) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      );
      const nextOptions = filtered.slice(0, internalPage * pageSize);
      setDisplayedOptions(nextOptions);
      setInternalPage(prev => prev + 1);
    } else if (props.hasMoreOptions && props.loadMoreOptions) {
      props.loadMoreOptions();
    }
  };

  return (
    <div>
      {props.label && (
        <div className="flex items-center text-sm  mb-1">
          <label className="block text-contrast-70 whitespace-nowrap cursor-default">
            {props.label}
          </label>
          {props.definition && (
            <p className="block text-contrast-70 text-darkblue-400 whitespace-nowrap ml-1 ">
              ({props.definition})
            </p>
          )}
          {props.required && <p className="block text-contrast-70">*</p>}
          {props.labelInfoIcon ? props.labelInfoIcon : null}
        </div>
      )}
      <div className="text-sm rounded-md leading-3 mr-2 w-full ">
        <StyledSelect
          id={props.id}
          styles={customStyles}
          menuPlacement={props.placement || "bottom"}
          placeholder={props.placeholder || "Seçiniz..."}
          options={props.isLazyFrontend ? displayedOptions : props.options}
          defaultValue={props.defaultValue}
          isSearchable={props.isSearchable ? true : false}
          onChange={(val, meta)=>{
            
            if (meta.action=="clear") {
              onChange({value : null})
            }else
            if (val) {
              onChange(val)
            }
        
          }}
          isMulti={props.isMulti ? true : false}
          classNamePrefix={props.classNamePrefix}
          className={props.className}
          onBlur={onBlur}
          menuPortalTarget={props.menuPortalTarget} 
          isDisabled={props.isDisabled ? true : false}
          ref={selectorRef}
          isClearable ={props.isClearable}
          value={props.value}
          onMenuScrollToBottom={handleScroll}
          onInputChange={(value, { action }) => {
            if (action === "input-change") {
              setInputValue(value);
          
              if (props.isLazyFrontend) {
                const filtered = props.options.filter((option: any) =>
                  option.label.toLowerCase().includes(value.toLowerCase())
                );
                const pageSize = props.lazyPageSize || 50;
                setDisplayedOptions(filtered.slice(0, pageSize));
                setInternalPage(2);
              }
            }
          }}
          onMenuClose={() => {
            setInputValue("");
          }}
          noOptionsMessage={() => props.loading ? 'Yükleniyor...' : 'Veri Yok'} 
        />
      </div>

      {props.labelHelper && (
        <p className="mt-2 text-2xs text-contrast-70">{props.labelHelper}</p>
      )}
      {meta.touched && meta.error && (
        <p className="mt-2 text-sm text-error-text">{(meta.error)}</p>
      )}
      {props.successText && (
        <p className="mt-2 text-sm success-text">{props.successText}</p>
      )}
    </div>
  );
}
